module.exports = __webpack_public_path__ + "static/img/zzy3.483cf98.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/zzy3.png
// module id = TxoU
// module chunks = 73